













































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

import RouteAssistant from '@/helpers/route-assistant'

/* Data types */
import * as actionTypes from '@/services/store/action-types'
import { INotificationsOutputNotification } from '@/api/types/response.types'

/* API */
import NotificationsAPI from '@/api/modules/notifications.api'

export default Vue.extend({
  name: 'AppHeaderNotification',

  data() {
    return {
      max: 4,
      isLoading: false,
      listNotifications: [] as INotificationsOutputNotification[],
    }
  },

  watch: {
    '$store.state.profile.notifications': {
      immediate: true,
      handler(val: INotificationsOutputNotification[]) {
        this.listNotifications = val
      },
    },
  },

  methods: {
    onVisibilityChange(visibility: boolean) {
      // only for mobile
      if (this.$screen.isMobile(this.$mq)) {
        if (visibility) {
          // @ts-ignore
          this.$bodyScroll.disable()
        } else {
          // @ts-ignore
          this.$bodyScroll.enable()
        }
      }
    },

    async handleCommand(item: any) {
      try {
        await NotificationsAPI.post_Read(item.id)
        await this.$store.dispatch(`profile/${actionTypes.NOTIFICATIONS_FETCH}`)
        this.goToNotificationUrl(item.url)
      } catch (error) {
        this.$error.emit(error)
      }
    },

    async clearNotifications() {
      try {
        await NotificationsAPI.post_Clear()
        await this.$store.dispatch(`profile/${actionTypes.NOTIFICATIONS_FETCH}`)
        if (this.$screen.isMobile(this.$mq)) {
          /* Re-enable scrolling that was disabled for mobile upon showing dropdown */
          // @ts-ignore
          this.$bodyScroll.enable()
        }
      } catch (error) {
        this.$error.emit(error)
      }
    },

    goToNotificationUrl(url: string): void {
      /* Notification urls should be the "beta-redirect" urls */
      const relativeMarker = 'project-type'

      /* If this is another kind of notification url, just go to it... */
      if (url.indexOf(relativeMarker) === -1) {
        RouteAssistant.goToUrl(url)
        return
      }

      const relativeUrl = url.substring(
        url.indexOf(relativeMarker) + relativeMarker.length,
      )

      const numbers = relativeUrl.match(/\d+/g).map(Number)
      let projectTypeID = 0
      let projectID = 0
      let itemID = 0
      let eventID = null
      const accountID = this.$route.params.accountId

      if (numbers.length === 3) {
        // e.g. https://2.donedone.com/app/1/beta-redirect/project-type/2/items/4468/conversation/28291
        projectTypeID = numbers[0]
        projectID = numbers[1]
        itemID = numbers[2]
      } else if (numbers.length === 4) {
        // e.g. https://2.donedone.com/app/1/beta-redirect/project-type/2/items/4468/conversation/28291?item_event_id=97599
        projectTypeID = numbers[0]
        projectID = numbers[1]
        itemID = numbers[2]
        eventID = numbers[3]
      } else {
        RouteAssistant.goToUrl(url)
        return
      }

      const isTask = projectTypeID === 1

      // project
      if (isTask) {
        RouteAssistant.goToTask(
          this.$router,
          accountID,
          projectID,
          itemID,
          this.$permissions,
          null,
          null,
          null,
          null,
          eventID,
        )
      } else {
        RouteAssistant.goToConversation(
          this.$router,
          accountID,
          projectID,
          itemID,
          null,
          null,
          null,
          null,
          eventID,
        )
      }
    },
  },
})
